import { DialogLocal } from "@/components/Dialog";
import { useConfigStore } from "@/stores";
import { useUserInfoStore } from "@/stores/userInfo";
import { AutoCenter } from "antd-mobile";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export const useSetup = () => {
  const navigate = useNavigate();
  const [userinfo] = useUserInfoStore()((state) => [state.userInfo]);
  const configStore = useConfigStore();

  const isGoogleAuthOpen = useMemo(() => {
    return userinfo.isGoogleAuthenticator === 1;
  }, [userinfo.isGoogleAuthenticator]);

  const isBindPhone = useMemo(() => {
    return userinfo.isEnteredPhoneNumber !== 1 ? false : true;
  }, [userinfo.isEnteredPhoneNumber]);

  const isBindPwd = useMemo(() => {
    return userinfo.isEnteredPassword;
  }, [userinfo.isEnteredPassword]);

  const isSetUserName = useMemo(() => {
    return userinfo.isUserName === 1 || !!userinfo.userName;
  }, [userinfo.userName, userinfo.isUserName]);

  const registerMode = useMemo(() => {
    return configStore.config ? configStore.config.userRegisterType : "2";
  }, [configStore.config]);

  const onGoogleAuthInput = (checked: boolean) => {
    if (checked) {
      navigate("/bind_google_auth");
    } else {
      navigate("/unbind_google_auth");
    }
  };

  const checkIfSetUsername = (path: string, isBind: boolean) => {
    if (registerMode === "1") {
      if (isSetUserName) {
        navigate(path);
      } else {
        return {
          content: "请设置用户名!",
          onClose: () => {
            navigate("/user_name", { replace: true });
          },
        };
      }
    }
    if (registerMode === "2") {
      if (isBindPhone) {
        navigate(path);
      } else {
        return DialogLocal({
          content: <AutoCenter>请绑定手机号!</AutoCenter>,
          onConfirm: () => {
            navigate("/user_bind_phone", { replace: true });
          },
        });
      }
    }
  };
  return {
    userinfo,
    isBindPwd,
    isBindPhone,
    isGoogleAuthOpen,
    onGoogleAuthInput,
    checkIfSetUsername,
  };
};
